import { ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
  selector: 'app-button-set',
  templateUrl: './button-set.component.html',
  styleUrls: ['./button-set.component.scss']
})
export class ButtonSetComponent {

  @Input() align: 'left' | 'right' = 'left' 
  @Input() marginTop: '10px';
  @Input() marginBottom: '0';
  
  constructor(
    protected _changeDetectorRef: ChangeDetectorRef
  ) {
  }
}
